import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

export type NotificationType = "SUCCESS" | "ERROR" | "DEFAULT";
export interface Notification {
  id: string;
  messages?: string[];
  translatedMessages?: string[];
  type: NotificationType;
  closable?: boolean;
  slideout?: boolean;
}

export interface NotificationState {
  notifications: Notification[];
}

const initialState: NotificationState = {
  notifications: [],
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    showNotification: {
      reducer: (state, action: PayloadAction<Notification>) => {
        state.notifications.unshift(action.payload);
      },
      prepare: (notification: Omit<Notification, "id">) => {
        const id = uuidv4();
        return {
          payload: {
            ...notification,
            id,
          },
          meta: { id },
        };
      },
    },
    clearNotification(state, action: PayloadAction<string>) {
      state.notifications = state.notifications.filter(
        (n) => n.id !== action.payload
      );
    },
    clearSlideoutNotifications(state) {
      state.notifications = state.notifications.filter((n) => !n.slideout);
    },
    clearDismissibleNotifications(state) {
      state.notifications = state.notifications.filter((n) => !n.closable);
    },
    clearAllNotifications(state) {
      state.notifications = [];
    },
  },
});

export const {
  showNotification,
  clearNotification,
  clearSlideoutNotifications,
  clearDismissibleNotifications,
  clearAllNotifications,
} = notificationSlice.actions;
export default notificationSlice.reducer;
